import { API } from '../API'

export const populateCollegeData = async (institution) => {
  console.time("populateCollegeData")
  const [campuses, personnel, classes] = await Promise.all([
    (async () => {
      const result = await API.getMultipleCampusById(institution.campuses)
      return result?.data
    })(),
    (async () => {
      const result = await API.getPersonnelByInstId(institution._id)
      return result?.data
    })(),
    (async () => {
      const result = await API.getClassesByCampuses(institution.campuses)
      return result?.data
    })()
  ])
  
  console.timeEnd("populateCollegeData")

  return { institution, campuses, personnel, classes }
}

export const getProgressCollege = (user, institution, classes, campuses, personnel) => {
  let p_c = {
    logo: !!institution.logo,
    website: !!institution.website_url,
    profile_photo: !!user.photo,
    campuses: campuses && campuses.length > 0,
    classes: classes && classes.length > 0,
    personnel: personnel && personnel.length > 0,
    courses: !!(institution.selected_can_delivers?.length > 0 || institution?.selected_rooms_programs?.length > 0),
    // payment: false
  }
  // var p_c = [false, false, false, false, false, false, false];
  // institution.logo ? (p_c[0] = true) : (p_c[0] = false);
  // p_c[0] = !!institution.logo
  // p_c[1] = classes && classes.length > 0
  // // user.photo ? (p_c[2] = true) : (p_c[2] = false);
  // p_c[2] = !!user.photo
  // p_c[3] = !!(Object.values(institution.can_deliver)
  //   .find(cd => typeof (cd) === "object" && cd.length > 0)); // courses delivered
  // p_c[4] = campuses && campuses.length > 0;
  // p_c[5] = false; // Payment method
  // p_c[6] = personnel && personnel.length > 0;
  // p_c[7] = !!institution.website_url;
  // var progress = 0;
  // for (var i = 0; i < p_c.length; i++) {
  //   if (p_c[i]) {
  //     progress++;
  //   }
  // }

  let arr = Object.values(p_c);
  let progress = arr.reduce((total = 0, p) => {
    // console.log(total, p)
    if (p) {
      total++;
    }
    return total;
  })
  progress = Math.round((progress / arr.length) * 100);

  return { progress, p_c }
}